import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss'],
    standalone: false
})
export class LandingComponent implements OnInit {
    constructor(private translocoService: TranslocoService) {}

    ngOnInit(): void {
        let activelang = navigator.language.split('-');
        let res = this.translocoService.getAvailableLangs().some((x) => x == activelang[0]);
        if (res === true) {
            this.translocoService.setActiveLang(activelang[0]);
        }
    }
}
